if (!customElements.get('norea-flash-offer')) {
  class NoreaFlashOffer extends HTMLElement {
    connectedCallback() {
      this.info = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      this.section = this.closest('.shopify-section');
      this.section?.classList.add('norea-flash-section');
      this.variants = JSON.parse(this.querySelector('[data-norea-variants]')?.textContent || '[]');
      this.sticky = this.querySelector('[data-norea-sticky]');
      this.addButton = this.querySelector('[data-norea-add]');
      this.onChange = () => this.syncVariant();
      this.onAdd = () => {
        const form = document.getElementById(this.dataset.formId);
        const button = form?.querySelector('[name="add"]');
        if (!button || button.disabled) {
          this.info?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        button.click();
      };
      this.addButton?.addEventListener('click', this.onAdd);
      this.info?.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.syncVariant());
      if (this.info) this.observer.observe(this.info, { childList: true, subtree: true });
      this.syncVariant();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
      const nativeButton = document.getElementById(this.dataset.formId)?.querySelector('[name="add"]');
      if (nativeButton && this.sticky && 'IntersectionObserver' in window) {
        this.buttonObserver = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
          document.body.classList.toggle('norea-flash-has-sticky', !this.sticky.hidden);
        }, { threshold: 0 });
        this.buttonObserver.observe(nativeButton);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
      this.info?.removeEventListener('change', this.onChange);
      this.addButton?.removeEventListener('click', this.onAdd);
      this.section?.classList.remove('norea-flash-section');
      document.body.classList.remove('norea-flash-has-sticky');
    }
    setText(selector, value) {
      const node = this.querySelector(selector);
      if (node && node.textContent !== String(value)) node.textContent = value;
    }
    syncVariant() {
      const form = document.getElementById(this.dataset.formId);
      const variant = this.variants.find(item => String(item.id) === form?.querySelector('[name="id"]')?.value);
      if (!variant) return;
      this.setText('[data-norea-price]', variant.price);
      this.setText('[data-norea-sticky-price]', variant.price);
      this.setText('[data-norea-compare]', variant.compare);
      this.setText('[data-norea-discount]', variant.discount);
      this.setText('[data-norea-saving]', variant.saving);
      this.querySelector('[data-norea-compare]').hidden = !variant.hasSale;
      this.querySelector('.norea-flash__discount').hidden = !variant.hasSale;
      this.querySelector('[data-norea-saving]').hidden = !variant.hasSale;
      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        const label = variant.available ? this.dataset.labelCart : this.dataset.labelUnavailable;
        if (this.addButton.textContent !== label) this.addButton.textContent = label;
      }
    }
    tick() {
      const countdown = this.querySelector('[data-norea-countdown]');
      if (!countdown || !this.dataset.end.trim()) return;
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end)) {
        this.setText('[data-norea-count-label]', this.dataset.labelInvalid);
        return;
      }
      const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const units = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [unit, value] of Object.entries(units)) this.setText(`[data-time="${unit}"]`, String(value).padStart(2, '0'));
      if (!seconds) {
        this.setText('[data-norea-count-label]', this.dataset.labelEnded);
        clearInterval(this.timer);
      }
    }
  }
  customElements.define('norea-flash-offer', NoreaFlashOffer);
}
